import { useLang } from '../context/LanguageContext';
import { LEADERSHIP_TEAM } from '../config/business';
import './FooterAboutLeadership.css';

function LeaderCard({ leader, role, index }) {
  return (
    <article className="about-leader">
      <div className="about-leader__visual">
        <div className="about-leader__photo-wrap">
          <img
            src={leader.image}
            alt={leader.name}
            className="about-leader__photo"
            loading="lazy"
            decoding="async"
          />
        </div>
        <span className="about-leader__index" aria-hidden>
          {String(index + 1).padStart(2, '0')}
        </span>
      </div>
      <div className="about-leader__info">
        <span className="about-leader__role">{role}</span>
        <h4 className="about-leader__name">{leader.name}</h4>
      </div>
    </article>
  );
}

export default function FooterAboutLeadership({ className = '', showTitle = true }) {
  const { t } = useLang();

  return (
    <section
      className={`about-leadership ${className}`.trim()}
      aria-labelledby={showTitle ? 'about-leadership-title' : undefined}
    >
      {showTitle && (
        <header className="about-leadership__header">
          <p id="about-leadership-title" className="about-leadership__eyebrow">
            {t.aboutLeadershipHeading}
          </p>
          <div className="about-leadership__rule" aria-hidden>
            <span />
            <span />
          </div>
        </header>
      )}
      <div className="about-leadership__grid">
        {LEADERSHIP_TEAM.map((leader, index) => (
          <LeaderCard
            key={leader.id}
            leader={leader}
            role={t[leader.roleKey]}
            index={index}
          />
        ))}
      </div>
    </section>
  );
}
